export const appMixin = {
  data() {
    return {
      appName: 'Arvessa',
      appStoreLink: 'itms-apps://itunes.apple.com/app/id6751053794',
      primaryColor: '#e859a1',
      termsOfService: 'https://arvessa.vip/desktop/terms_of_service',
      privacyPolicy: 'https://arvessa.vip/desktop/privacy_policy',
      email: "arisa2025@163.com",
      org: '',
      orgAdress: '',
      discord: 'https://discord.gg/wn5d72qtet',
      shopLink: {
        pre: 'https://pre-shop.cozytaps.com',
        online: 'https://shop.cozytaps.com'
      }
    }
  },

  methods: {
    getShopDomain() {
      return this.shopLink[APP_ENV.VUE_APP_ENVIRONMENT] || this.shopLink.pre;
    }
  }
}